export function calculatorSlider() {

    const calculator_slider = document.querySelector('.calculator_slider');

    if (!calculator_slider) {
        return false;
    }

    function initCalculatorsSlider() {

        $('.calculator_slider').not('.slick-initialized').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            swipe: false,
            prevArrow: $('.calculator_prev'),
            nextArrow: $('.calculator_next'),
            adaptiveHeight: true
        });
    }

    $('[value="have_website"]').click(function () {
        $('[name="domain"]').show();
    });

    $('[value="havent_website"]').click(function () {
        $('[name="domain"]').hide();
    });

    function adaptive(script) {
        script();

        ['resize', 'orientationChange'].forEach( function(item) {
            window.addEventListener(item, script);
        });
    }

    adaptive(initCalculatorsSlider);

    $('.calculator_slider').on('afterChange', function (event, slick, currentSlide) {
        var current_index = Number($('.calculator_slider .slick-active').attr('data-slick-index'));
        $('.calculator_step.active_step').removeClass('active_step');
        $('.calculator_step[data-step="' + (current_index + 1) + '"]').addClass('active_step');

        if (current_index > 0) {
            $('.calculator_prev.hidden_button').removeClass('hidden_button');
            $('.calculator_prev').addClass('show_button');
        }

        if (current_index == 0) {
            $('.calculator_prev.show_button').removeClass('show_button');
            $('.calculator_prev').addClass('hidden_button');
        }

        if (current_index == 4) {
            $('.calculator_next.show_button').removeClass('show_button');
            $('.calculator_next').addClass('hidden_button');
        }

        if (current_index < 4) {
            $('.calculator_next.hidden_button').removeClass('hidden_button');
            $('.calculator_next').addClass('show_button');
        }
    });

    $('.calculator_end').click(function (e) {
        if ($('.calculator_slider').slick('slickCurrentSlide') != 4) {
            $('.calculator_slider').slick('slickGoTo', 4, true);
        } else {
            var have_website = $('.final_calculator_data [name="have_website"]:checked').val();
            var errors = false;

            if (have_website == "have_website") {
                var sitename = $('.final_calculator_data [name="domain"]').val();
                var agreement = $('.final_calculator_data [name="agreement"]').prop('checked');

                if (sitename == "") {
                    $('.final_calculator_data [name="domain"]').addClass('wrong_field');
                    errors = true;
                } else {
                    $('.final_calculator_data [name="domain"]').removeClass('wrong_field');
                }

                if (!agreement) {
                    errors = true;
                    $('.final_calculator_data .agreement_section label').addClass('wrong_field');
                } else {
                    $('.final_calculator_data .agreement_section label').removeClass('wrong_field');
                }
            }

            if (!errors) {
                $('input[name="calculator_type"]').val($('input[name="calc_type"]:checked').val());
                $('input[name="calculator_region"]').val($('input[name="calc_region"]:checked').val());
                $('input[name="calculator_theme"]').val($('input[name="calc_theme"]:checked').val());
                $('input[name="calculator_cms"]').val($('input[name="calc_cms"]:checked').val());
                $('input[name="calculator_comment"]').val($('input[name="calc_comment"]').val());

                if (have_website == "have_website") {
                    $('input[name="calculator_domain"]').val("Есть сайт");
                } else {
                    $('input[name="calculator_domain"]').val("Нет сайта");
                }

                var price_from = 15000;
                var type = $('input[name="calculator_type"]').val();
                var region = $('input[name="calculator_region"]').val();

                if (type == "Лэндинг" || type == "Визитка") {
                    price_from = 15000;
                }

                if (type == "Интернет-магазин" || type == "Корпоративный сайт" || type == "Сайт услуг") {
                    price_from = 20000;
                }

                if (region == "Москва" || region == "Москва и МО" || region == "Санкт-Петербург") {
                    price_from += 5000;
                }

                $('.price_from').text(String(price_from));

                $('[data-modalbtn="calculator"]').click();
            }
        }
    });

    /*$('.calculator_step').click(function () {
        $('.calculator_slider').slick('slickGoTo', String($(this).attr('data-step') - 1), true);
        console.log($(this).attr('data-step') - 1);
    });*/

}
